import { useSelector, useDispatch } from 'react-redux';
import { useEffect } from 'react';
import { RootState } from '@/store/storeTTS';
import { useDeviceState, useVisionMode } from '@/libTTS/useCommon';
import { setVolume, updateScene, updateAIConfig, updateModelMode, setHistoryMsg, updateLocalUser } from '@/store/storeTTS/slices/room';
import { SCENE, Welcome, Model,AI_MODEL } from '@/configTTS/common';
import RtcClient from '@/libTTS/RtcClient';
import { COMMAND } from '@/utils/utilsTTS/handler';
import { StreamIndex } from '@volcengine/rtc';
import styles from './index.module.less';
import CameraCloseNoteSVG from '@/assets/img/CameraCloseNote.svg';
import Config from '@/configTTS';
import camera from '@/assets/img/camera.svg';
const LocalVideoID = 'local-video-player';
const LocalScreenID = 'local-screen-player';

function CameraArea(props: React.HTMLAttributes<HTMLDivElement> & { forceShow?: boolean }) {
  const { className, forceShow = false, ...rest } = props;
  const room = useSelector((state: RootState) => state.room);
  const { isVisionMode } = useVisionMode();
  const dispatch = useDispatch();
  // 修改：使用 useVisionMode 中的 isScreenMode
  const { isScreenMode } = useVisionMode();
  const { isVideoPublished, isScreenPublished, switchCamera, switchScreenCapture } =
    useDeviceState();

  const setVideoPlayer = () => {
    if ((isVisionMode || forceShow) && (isVideoPublished || isScreenPublished)) {
      console.log('Setting video player:', { isVisionMode, forceShow, isVideoPublished, isScreenPublished, isScreenMode });
      const useScreenPlayer = isScreenPublished;
      RtcClient.setLocalVideoPlayer(
        room.localUser.username!,
        isScreenMode ? LocalScreenID : LocalVideoID,
        useScreenPlayer
      );
    }
  };
  const handleSwitchAIScene = (scene: SCENE) => {
    dispatch(updateScene({ scene }));
    Config.WelcomeSpeech = Welcome[scene];
  };
  // 切换AI模型到视觉模式
  const switchToVisionModel = () => {
    // 在切换模型前，先清除当前正在进行的AI回答
    if (RtcClient.getAudioBotEnabled()) {
      RtcClient.commandAudioBot(COMMAND.INTERRUPT);
    }
    Config.Model = AI_MODEL.VISION;
    dispatch(updateModelMode(Config.ModeSourceType));
    dispatch(updateAIConfig(Config.aigcConfig));
  };
  //控制视频
  const handleSwitchCamera = async (enable?: boolean) => {
    const enableCamera = enable !== undefined ? enable : !isVideoPublished;
    // 在切换前清除历史消息和当前AI状态
    dispatch(setHistoryMsg([]));
    if (RtcClient.getAudioBotEnabled()) {
      RtcClient.commandAudioBot(COMMAND.INTERRUPT);
    }
    if (enableCamera) {
      handleSwitchAIScene(SCENE.TEACHING_ASSISTANT);
      if (isScreenPublished) {
        await switchScreenCapture(false);
      }
      
      try {
        await switchCamera(true);
        switchToVisionModel();
        Config.VisionSourceType = StreamIndex.STREAM_INDEX_MAIN;
      } catch (error) {
        // 处理摄像头权限被拒绝的情况
        console.error('摄像头权限被拒绝:', error);
        // 发送事件通知ToolBar组件更新状态
        window.dispatchEvent(new CustomEvent('cameraPermissionError', { detail: { error: true } }));
        
        // 确保摄像头状态被正确设置为关闭
        dispatch(updateLocalUser({
          publishVideo: false,
        }));
        
        // 清理视频播放器
        try {
          RtcClient.setLocalVideoPlayer(
            room.localUser.username!,
            undefined,
            false
          );
        } catch (playerError) {
          console.error('清理视频播放器时出错:', playerError);
        }
        return;
      }
    } else {
      try {
        await switchCamera(false);
        if (!isScreenPublished) {
          handleSwitchAIScene(SCENE.INTELLIGENT_ASSISTANT);
          Config.Model = Model[SCENE.INTELLIGENT_ASSISTANT];
          dispatch(updateModelMode(Config.ModeSourceType));
          dispatch(updateAIConfig(Config.aigcConfig));
        }
      } catch (error) {
        console.error('关闭摄像头时出错:', error);
      }
    }

    if (RtcClient.getAudioBotEnabled()) {
      await RtcClient.updateAudioBot();
    }
  };
  // const handleOperateCamera = async () => {
  //   await switchCamera(true);
  //   setTimeout(() => {
  //     if (!isVideoPublished) {
  //       setVideoPlayer();
  //     }
  //   }, 300);
  // };

    const handleSwitchScreenCapture = async (enable?: boolean) => {
        const enableScreen = enable !== undefined ? enable : !isScreenPublished;
        // 在切换前清除历史消息和当前AI状态
        dispatch(setHistoryMsg([]));
        if (RtcClient.getAudioBotEnabled()) {
            RtcClient.commandAudioBot(COMMAND.INTERRUPT);
        }

        if (enableScreen) {
            handleSwitchAIScene(SCENE.SCREEN_READER);
            if (isVideoPublished) {
                await switchCamera(false);
            }
            switchScreenCapture();
            // 只有在不是视觉模式时才切换到视觉模式
            if (Config.Model !== AI_MODEL.VISION) {
                switchToVisionModel();
            }
            Config.VisionSourceType = StreamIndex.STREAM_INDEX_SCREEN;
        } else {
            switchScreenCapture(false);
            if (!isVideoPublished) {
                handleSwitchAIScene(SCENE.INTELLIGENT_ASSISTANT);
            }
        }
        if (RtcClient.getAudioBotEnabled()) {
            await RtcClient.updateAudioBot();
        }
       
    };

  useEffect(() => {
    setVideoPlayer();
  }, [isVideoPublished, isScreenPublished, isScreenMode, forceShow]);

  const shouldShow = forceShow || isVisionMode;

  return shouldShow ? (
    <div className={`${styles['camera-wrapper']} ${className}`} {...rest}>
      <div
        id={LocalVideoID}
        className={`${styles['camera-player']} ${isVideoPublished && !isScreenMode ? '' : styles['camera-player-hidden']
          }`}
      />
      <div
        id={LocalScreenID}
        className={`${styles['camera-player']} ${isScreenPublished && isScreenMode ? '' : styles['camera-player-hidden']
          }`}
      />
       <div className={styles['camera-placeholder-close-all']}>
          <div className={styles['camera-placeholder-close-img']}>
            <img src={camera} alt="" style={{ width: '16px', height: '16px' }} />
          </div>
          <div className={styles['camera-placeholder-close-text']}>
            我
          </div>
        </div>
      <div
        className={`${styles['camera-placeholder']} ${isVideoPublished || isScreenPublished ? styles['camera-player-hidden'] : ''
          }`}
      >
        <img
          src={CameraCloseNoteSVG}
          alt="close"
          className={styles['camera-placeholder-close-note']}
        />
        <div>
          <div>
            <span className={styles['camera-open-size']}>打开</span>
            <span className={styles['camera-open-btn']} onClick={()=>handleSwitchScreenCapture()}>
              屏幕共享
            </span>
            <span className={styles['camera-open-size']}>或</span>
            <span className={styles['camera-open-btn']} onClick={() => handleSwitchCamera()}>
              视频通话
            </span>
          </div>
        </div>
      </div>
    </div>
  ) : null;
}

export default CameraArea;